<div class="notify-overlay" (click)="$event.stopPropagation()"></div>
<div class="modal-header">
  <h4 class="modal-caption">{{ caption | translate }}</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="bsModalRef.hide()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="modal-message">{{ message | translate }}</div>
</div>
<div class="modal-footer">
  <button type="button" class="fn-btn fn-btn-default" (click)="bsModalRef.hide()">{{ closeBtnName | translate }}</button>
</div>
<div style="display: none">{{ developerMessage }}</div>
